import React,{useState} from 'react'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

function MerTime(props) {
  
  const [value, setValue] = useState(props.info.value!==''?props.info.value:null);
  const handleChange = (newValue) => {
    setValue(newValue);
    props.handleChange(props.info?.id,newValue,props.info?._id);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          label={props.info.question_text}
          value={value}
          disabled={!props.abled}
          onChange={handleChange}
          renderInput={(params) => 
            <TextField 
            InputLabelProps={{
                style: { color: 'black' },
            }}
            sx={{marginBottom:2,marginTop:2, maxWidth:'75%' , 
                '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                  borderColor: 'black',
                },
               },
               '& .MuiFormLabel-asterisk': {
                color: 'red', fontSize: '30px'
               },
            }}
            required={props.info.mandatory}
            autoComplete='off'
            value={value}
            label={props.info.question_text}
            variant="outlined"
            {...params}
            />}
        />
    </LocalizationProvider>
  )
}

export default MerTime
